<template>
  <div class="  mr0 ml0 boxWrapper ">
    <div class="box-item left">
      <!-- 快捷入口 -->
      <a-card title="快捷入口" :bordered="false" class=" mb10">
        <template #extra
          ><a @click="isOpenTag = true" v-btnroot="'addTag'"
            >添加标签</a
          ></template
        >
        <a-row :gutter="10" v-if="quickEntryList.length > 0">
          <a-col
            class="cp"
            :span="6"
            v-for="item in quickEntryList"
            :key="item.tagName"
            @click="toJump(item.tagURL)"
          >
            <div class="card-item df  fdc jcc">
              <p class="menu">{{ item.systemName }}</p>
              <p class="sys">{{ item.tagName }}</p>
            </div>
            <img
              v-if="item.type == 2"
              src="@/assets/img/hot.svg"
              class="icon-tag"
              alt=""
            />
            <img
              v-if="item.type == 3"
              src="@/assets/img/new.svg"
              class="icon-tag new"
              alt=""
            />
          </a-col>
        </a-row>
        <a-empty v-else></a-empty>
      </a-card>
      <!-- 项目进度 -->
      <a-tabs
        v-model:activeKey="state.activeIndex"
        class="b-fff"
        style="margin-bottom:0;"
      >
        <template #tabBarExtraContent>
          <a-radio-group
            v-if="state.activeIndex === 2"
            v-model:value="state.radioType"
            size="small"
            @change="changeRadio"
          >
            <a-radio-button :value="1">只关注自己的</a-radio-button>
            <a-radio-button :value="2">查看所有</a-radio-button>
          </a-radio-group>
          <a-button
            type="link"
            class="ml10"
            @click="
              submitAdvice(
                {
                  type: 2,
                  message: '申请查看销量数据'
                },
                false
              )
            "
            >查看销量数据</a-button
          >
        </template>
        <a-tab-pane :key="1" tab="值班系统">
          <a-card :bordered="false" class=" scheduleList ">
            <!-- <template #extra>
              <a-button
                type="link"
                @click="
                  submitAdvice(
                    {
                      type: 2,
                      message: '申请查看销量数据'
                    },
                    false
                  )
                "
                >查看销量数据</a-button
              >
            </template> -->
            <iframe
              width="100%"
              height="600px"
              :src="formatPath(state.ScheduleURL)"
              frameborder="0"
            ></iframe>
          </a-card>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="项目问题">
          <a-card :bordered="false" class=" project-process">
            <!-- <template #extra>
              <a-radio-group
                v-model:value="state.radioType"
                size="small"
                @change="changeRadio"
              >
                <a-radio-button :value="1">只关注自己的</a-radio-button>
                <a-radio-button :value="2">查看所有</a-radio-button>
              </a-radio-group>
            </template> -->
            <a-tabs
              v-model:activeKey="activeKey"
              type="editable-card"
              size="small"
              hideAdd
              @edit="onEdit"
              @change="changeTab"
            >
              <a-tab-pane
                :tab="item.name"
                :id="item.id"
                v-for="(item, index) in localJiraProject"
                :key="index"
              >
                <template v-if="searchResults.length">
                  <div
                    class="con-item mb10 cp"
                    v-for="item in searchResults"
                    :key="item.id"
                    @click="openJira(item)"
                  >
                    <div class="info">
                      <div class="tit">{{ item.fields.summary }}</div>
                      <div class="tags">
                        <a-tag color="#FFA39E" v-if="item.fields.priority">{{
                          item.fields.priority.name
                        }}</a-tag>
                        <a-tag
                          color="#FFE58F"
                          v-if="item.fields.customfield_10322"
                          >{{ item.fields.customfield_10322.value }}</a-tag
                        >
                        <a-tag>{{ item.fields.status.name }}</a-tag>
                      </div>
                      <div class="name">
                        当前处理人：{{
                          item.fields.assignee &&
                            item.fields.assignee.displayName
                        }}
                      </div>
                      <div class="date">
                        创建时间：
                        {{
                          moment(item.fields.created).format(
                            'YYYY-MM-DD HH:mm:ss'
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </template>
                <a-empty :description="false" v-else style="margin-top:20%;" />
              </a-tab-pane>
              <template #tabBarExtraContent>
                <a-dropdown overlayClassName="projectDrop">
                  <a class="ant-dropdown-link ml40">
                    查看更多项目
                    <DownOutlined />
                  </a>
                  <template #overlay>
                    <div>
                      <a-checkbox-group v-model:value="state.checkeds">
                        <div v-for="(item, index) in jiraProjects" :key="index">
                          <a-checkbox
                            @change="onChangeCheckbox"
                            :value="item.id"
                            :id="item.id"
                            >{{ item.name }}</a-checkbox
                          >
                        </div>
                      </a-checkbox-group>
                    </div>
                  </template>
                </a-dropdown>
              </template>
            </a-tabs>
          </a-card>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class=" box-item ">
      <!-- 右边box -->
      <div class=" b-fff   weatherWrapper mb10 ">
        <!-- 天气 -->
        <a-row
          align="middle"
          class="weather-degree"
          :class="state.yiket.wea_img"
        >
          <p class="degree">{{ state.yiket.tem }}&#176;</p>
          <div class="f1">
            <p class="date">
              {{ state.yiket.week }}
              {{ moment(state.yiket.date).format('MM/DD') }}
            </p>
            <p class="weather">今日{{ state.yiket.wea }}</p>
          </div>
        </a-row>
        <a-row align="middle" justify="space-around" class="other">
          <div>
            <p>{{ state.yiket.humidity }}</p>
            <span>湿度</span>
          </div>
          <div>
            <p>{{ state.yiket.air }}</p>
            <span>PM 2.5</span>
          </div>
          <div>
            <p>{{ state.yiket.win_speed }}</p>
            <span>风级</span>
          </div>
        </a-row>
      </div>

      <div class=" b-fff    mb10" style="display:none">
        <a-card title="公司新闻" :bordered="false" class="bbs ">
          <ul>
            <li v-for="(item, index) in bbsList" :key="index">
              <a
                @click="toHref(`https://bbs.kapeixi.cn/${item.url}`)"
                class="df"
              >
                <div
                  class="img"
                  :style="{
                    'background-image': `url(https://bbs.kapeixi.cn/${item.pic})`
                  }"
                ></div>
                <div class="con f1">
                  <p class="tit">{{ item.title }}</p>
                  <p class="info df aic">
                    <span class="f1">
                      <!-- <span>{{ item.author }}</span> &nbsp;|
                    <span>{{ item.dateline }}</span
                    >&nbsp;| -->
                      <span>{{ item.forumname }}</span>
                    </span>
                    <span>
                      <EyeOutlined class="fs12" style="transform:scale(0.8)" />
                      {{ item.views }}
                      &nbsp;
                      <MessageOutlined
                        class="fs12"
                        style="transform:scale(0.8)"
                      />
                      {{ item.recommends }}
                    </span>
                  </p>
                </div>
              </a>
            </li>
          </ul>
        </a-card>
      </div>
      <div class=" b-fff  mb10 ">
        <a-card title="站内消息" :bordered="false" class="bbs ">
          <template #extra>
            <a-dropdown :trigger="['click']" v-model:visible="state.isVisible">
              <a
                class="ant-dropdown-link"
                @click.prevent="
                  () => {
                    state.message = null
                    state.isVisible = true
                  }
                "
              >
                意见反馈
              </a>
              <template #overlay>
                <div class="adviseForm">
                  <a-form
                    :model="state"
                    :rules="rules"
                    ref="formRef"
                    layout="vertical"
                  >
                    <a-form-item label="意见" name="message">
                      <a-textarea
                        style="width:300px"
                        :rows="3"
                        placeholder="在这里可反馈您的意见哦~"
                        v-model:value="state.message"
                      ></a-textarea>
                    </a-form-item>

                    <a-form-item class="tar" style="margin-bottom:0px;">
                      <a-button
                        size="small"
                        class="mr10"
                        @click="state.isVisible = false"
                        >取消</a-button
                      >
                      <a-button
                        size="small"
                        type="primary"
                        @click="
                          () => {
                            submitAdvice(
                              {
                                message: state.message,
                                type: 3
                              },
                              true
                            )
                            state.isVisible = false
                          }
                        "
                        >提交</a-button
                      >
                    </a-form-item>
                  </a-form>
                </div>
              </template>
            </a-dropdown>
          </template>
          <ul v-if="messageList.length > 0">
            <li v-for="(item, index) in messageList" :key="index" class="df">
              <div class="img">
                <a-avatar :src="item.avater" v-if="item.avater" />
                <a-avatar v-else>
                  {{ handlerUserName(item.userName) }}
                </a-avatar>
              </div>
              <div class="con f1">
                <div class="df tit">
                  <p class="mes_tit" v-html="item.message"></p>
                </div>
                <p class="info df aic mt10">
                  <span class="f1">
                    {{ moment(item.createdAt).calendar() }}
                  </span>
                  <span class="mes_name">{{ item.userName }} &nbsp;</span>
                </p>
              </div>
            </li>
          </ul>
          <a-empty v-else></a-empty>
        </a-card>
      </div>
    </div>
  </div>

  <HotTag v-if="isOpenTag" v-model:value="isOpenTag"></HotTag>
</template>
<script setup>
import { onMounted, reactive, watch } from 'vue'
import HotTag from './components/hotTag.vue'
import useAPI from 'UseApi'
import {
  StarOutlined,
  LikeOutlined,
  MessageOutlined,
  EyeOutlined
} from '@ant-design/icons-vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
// import { get } from 'server/axios.js'
import moment from 'moment'
const APIS = useAPI(null, [4231, 4285, 4321, 4333])
const store = useStore()
const state = reactive({
  radioType: 2,
  activeIndex: 1,
  projects: [],
  checkeds: [],
  yiket: {},
  // 是否展开全部项目
  showProjects: false,
  isVisible: false,
  message: null,
  ScheduleURL: process.env.VUE_APP_ToolBox + '/PortalScheduleList'
})

const router = useRouter()
const route = useRoute()
const formatPath = val => {
  const userInfo = store.state.user.userInfo
  const env = process.env.VUE_APP_MODE
  const systemId = store.state.app.otherSystemId

  let windowPath =
    val +
    (val && val.indexOf('?') > -1 ? '&' : '?') +
    `token=${userInfo.token}&email=${userInfo.email}&userId=${
      userInfo.userId
    }&userName=${userInfo.userName}&lang=${localStorage.getItem(
      'lang'
    )}&env=${env}&_t=${new Date().getTime()}&systemId=${systemId}`
  return windowPath
}
// 热门标签
const { quickEntryList, isOpenTag } = APIS.v1_hot_tag_upOnShelfAll_post_()

// 获取站内信
const { messageList } = APIS.v1_station_letter_index_post_()
const { submitAdvice, rules, formRef } = APIS.v1_station_letter_create_post_()

// BBS
const { bbsList } = APIS.v1_bbs_getNews_get_()

// 天气模块
const getWeather = async () => {
  const url = `https://v1.yiketianqi.com/free/day?appid=67451645&appsecret=wW8msQGn&vue=1&unescape=1`
  const result = await fetch(url).then(response => response.json())
  state.yiket = result
}
getWeather()

// 项目进度
const {
  jiraProjects,
  activeKey,
  localJiraProject
} = APIS.v1_jira_getAllProjects_get_()

const { executeSearchByJQL, searchResults } = APIS.v1_jira_searchByJQL_post_()

watch(
  () => localJiraProject.value,
  val => {
    if (val) {
      state.checkeds = val.map(item => item.id)
      changeTab(activeKey.value)
      localStorage.setItem('loc_jira_project', JSON.stringify(val))
    }
  },
  {
    deep: true
  }
)

// 只关注自己的问题
const changeRadio = e => {
  state.radioType = e.target.value
  changeTab(activeKey.value)
}
const onChangeCheckbox = e => {
  if (e.target.checked) {
    const item = jiraProjects.value.find(item => {
      return item.id === e.target.id
    })
    localJiraProject.value.push(item)
  } else {
    const index = localJiraProject.value.findIndex(
      item => item.id === e.target.id
    )
    remove(index)
  }
}
const onEdit = (targetKey, action) => {
  if (action === 'add') {
    // add()
  } else {
    remove(targetKey)
  }
}
const remove = index => {
  if (index > 0) {
    activeKey.value = index - 1
  }
  localJiraProject.value.splice(index, 1)
  localStorage.setItem(
    'loc_jira_project',
    JSON.stringify(localJiraProject.value)
  )
}
const changeTab = activeKey => {
  if (!localJiraProject.value.length) {
    message.warning('您当前下没有添加任何项目')
    return false
  }
  const projectName = localJiraProject.value[activeKey].name
  const jql = {
    project: localJiraProject.value[activeKey].name,
    issuetype: '缺陷',
    status: ['待修复', '待测试回归', '修复中', '待确认非问题']
  }
  const email = store.state.user.userInfo.email
  const option = state.radioType === 1 ? { assignee: email.split('@')[0] } : {}
  executeSearchByJQL({
    jql: Object.assign(jql, option),
    pageNum: 1,
    pageSize: 30
  })
}

const openJira = record => {
  window.open(`https://jira.kapeixi.cn/browse/${record.key}`)
}
const toHref = path => {
  if (path.startsWith('http')) {
    router.push({
      name: 'Iframe',
      query: {
        target: path
      }
    })
  } else {
    router.push({
      path
    })
  }
}

const toJump = path => {
  const menuList = store.state.user.menuList
  const index = menuList.findIndex(item => {
    return item.menuPath === path
  })
  if (index > -1) {
    toHref(path)
  } else {
    message.warning('您当前暂未开通权限，请联系管理员黄宇开通！！！')
  }
}
const handlerUserName = userName => {
  const names = userName.split('-')
  const name = names.length === 1 ? names[0] : names[1]
  if (name.length > 2) {
    return name.substring(name.length - 2, name.length)
  }
  return name
}
</script>
<style lang="scss" scoped>
.adviseForm {
  position: relative;
  margin: 0;
  padding: 16px;
  text-align: left;
  list-style-type: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 2px;
  outline: none;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  -webkit-transform: translate3d(0, 0, 0);
}
.h452 {
  height: 452px;
}
.ofy {
  overflow-y: auto;
}
.mr0 {
  margin-right: 0px !important;
}
.f1 {
  flex: 1;
}
.ml0 {
  margin-left: 0px !important;
}
.cp {
  cursor: pointer;
}
.boxWrapper {
  .box-item {
    width: calc(40% - 10px);
    float: left;
    break-inside: avoid; //避免在主体框中插入任何中断（页面，列或区域）。
    &.left {
      width: 60%;
      margin-right: 10px;
      .ant-card:first-child {
        height: 350px;
      }
    }
  }
}

.card-item {
  /* height: 78px; */
  padding: 8px 16px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 12px;

  .menu {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
  }
  .sys {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
}

.bbs {
  :deep .ant-card-body {
    padding: 0;
    height: 350px;
    overflow: auto;
  }
  ul {
    padding: 0 16px;
    li {
      border-bottom: 1px solid #f0f0f0;
      padding: 10px 0;
      .img {
        width: 44px;
        height: 44px;
        line-height: 44px;
        margin-right: 10px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      .tit {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      a {
        color: rgba(0, 0, 0, 0.85);
        cursor: pointer;
      }
      .mes_tit {
        /* color: #1890ff; */
        font-size: 14px;
        font-weight: normal;
      }
      .info {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}
.icon-tag {
  position: absolute;
  top: 0px;
  right: 6px;
  width: 40px;
  &.new {
    transform: rotate(90deg);
    width: 30px;
  }
}
.weatherWrapper {
  height: 208px;
  .weather-degree {
    padding: 0 32px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 132px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    &.yun {
      background-image: url(../../assets/img/yun.png);
    }
    &.yin {
      background-image: url(../../assets/img/yin.png);
    }
    &.qing {
      background-image: url(../../assets/img/qing.png);
    }
    &.yu {
      background-image: url(../../assets/img/yu.png);
    }
    &.lei {
      background-image: url(../../assets/img/lei.png);
    }
    &.wu {
      background-image: url(../../assets/img/wu.png);
    }
    &.shachen {
      background-image: url(../../assets/img/shachen.png);
    }
    &.xue {
      background-image: url(../../assets/img/xue.png);
    }
    &.bingbao {
      background-image: url(../../assets/img/bingbao.png);
    }
    .degree {
      font-size: 68px;
      line-height: 95px;
      margin-right: 24px;
    }
    .date {
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 1px;
      margin-bottom: 4px;
    }
    .weather {
      font-size: 24px;
      font-weight: 600;
      line-height: 33px;
      letter-spacing: 1px;
    }
  }
  .other {
    height: 76px;
    div {
      text-align: center;
      p {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
      }
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
    }
  }
}

.project-process {
  height: 700px;
  .con-item {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
    display: flex;
    &::before {
      content: '';
      width: 4px;
      min-height: 84px;
      background: #eff2f5;
      display: block;
      margin-right: 12px;
    }
    .tit {
      font-size: 14px;
      font-weight: 500;
      color: #1890ff;
      line-height: 22px;
    }
  }
}
</style>

<style lang="scss">
body .project-process {
  .ant-card-body {
    padding: 0 16px;
  }
  .ant-tabs-nav .ant-tabs-tab {
    padding: 8px;
    margin-right: 16px;
  }
  .ant-tabs-card-content {
    margin-top: 20px;
  }
  .ant-tabs-tabpane {
    height: 600px;
    overflow-y: auto;
  }
}
body .scheduleList {
  .ant-card-body {
    padding: 4px 0;
  }
}
.projectDrop {
  width: 180px;
  height: 200px;
  padding: 8px;
  overflow-y: auto;
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 8px;
  /* border: 1px solid #eaeaea; */
}
body .ant-form-item {
  margin-bottom: 10px;
}
body .ant-tabs-bar {
  margin-bottom: 0;
}
</style>
